import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { useAuth } from '../contexts/AuthContext';
import { Capability } from '../utils/capabilities';

const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: var(--background-color);
`;

const LoadingSpinner = styled.div`
  width: 50px;
  height: 50px;
  border: 3px solid var(--border-color);
  border-top: 3px solid var(--primary-color);
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

const LoadingText = styled.p`
  margin-top: 16px;
  color: var(--text-secondary);
  font-size: 16px;
`;

interface ProtectedRouteProps {
  children: React.ReactNode;
  // היכולת הנדרשת לגישה ל-route. ללא ערך = כל משתמש מחובר.
  // גידור זה הוא ל-UX בלבד — האכיפה בפועל נעשית בבקנד.
  capability?: Capability;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, capability }) => {
  const { isAuthenticated, isLoading, can } = useAuth();
  const location = useLocation();

  // Show loading state while checking authentication
  if (isLoading) {
    return (
      <LoadingContainer>
        <div>
          <LoadingSpinner />
          <LoadingText>טוען...</LoadingText>
        </div>
      </LoadingContainer>
    );
  }

  // Redirect to login if not authenticated (כולל טוקן ישן שנוקה בכפיית re-login)
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check the required capability if specified
  if (capability && !can(capability)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;